import styled from '@emotion/styled';
import { Box } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const BoxButton = styled(Box)`
  cursor: pointer;
`;

BoxButton.defaultProps = {
  as: 'button',
  border: 'none',
  bg: 'transparent',
  p: 0,
};

export const FullscreenImageWrapper = styled(Box)`
  flex: 1 1 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const ThumbnailsWrapper = styled(Box)`
  flex: 1 0 auto;
  margin-top: auto;
  overflow: hidden;
  width: 100%;
  flex-direction: column;
`;

export const DisplayMobilePortraitOnly = styled(Box)`
  ${mediaQuery.mobileLandscape} {
    display: none;
  }
`;
